import { render, staticRenderFns } from "./ComicDetail.vue?vue&type=template&id=7aca575a&scoped=true&"
import script from "./ComicDetail.vue?vue&type=script&lang=ts&"
export * from "./ComicDetail.vue?vue&type=script&lang=ts&"
import style0 from "./ComicDetail.vue?vue&type=style&index=0&id=7aca575a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aca575a",
  null
  
)

export default component.exports